<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="80px" size="mini">
        <div class="formItemBox">
            <el-form-item label="地址:" prop="address">
              <el-input  placeholder="" v-model="searchFrom.address"></el-input>
            </el-form-item>
            <el-form-item label="单位名称:" prop="">
              <el-input  placeholder="" v-model="searchFrom.company"></el-input>
            </el-form-item>
            <el-form-item label="联系人:" prop="person">
              <el-input  placeholder="" v-model="searchFrom.person"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="phone">
              <el-input  placeholder="" v-model="searchFrom.phone"></el-input>
            </el-form-item>
            <el-form-item label="流向:" class="diqu">
              <shengShiXian @handleChange="handleChange" :rowData="this.searchFrom" v-if="isShowAddressInfo"></shengShiXian>
            </el-form-item>
        </div>
         <div style="margin-left:20px;">
              <el-form-item>
                <el-button type="primary" @click="searchFn" size="mini">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetForm('searchFrom')" size="mini">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addressAdd" size="mini" v-if="btnFlg[0]||iszujian==1">新建地址</el-button>
              </el-form-item>
              <!-- <el-form-item>
                <el-button type="primary" @click="addressAddJH" size="mini" v-if="btnFlg[3]||iszujian==1">新建地址</el-button>
              </el-form-item> -->
          </div>
      </el-form>
    </div>
    <div class="table" :style="{height:h}">
      <el-table :data="xzdz" ref="xzdz" highlight-current-row  class="tableComent"  @current-change="handleCurrentChange" @row-dblclick="dbSelected" style="width: 100%" height="100%" border>
        <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="btnFlg[1]||iszujian==1" @click="modifyRegion(scope.row)">修改</el-button>
            <el-button type="text" size="mini" v-if="btnFlg[2]||iszujian==1" @click="delDeiver(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="company" label="单位名称" width="180" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="person" width="120" label="联系人"></el-table-column>
        <el-table-column prop="phone" width="130" label="联系电话"></el-table-column>
        <el-table-column prop="address" label="地址" show-overflow-tooltip ></el-table-column>
        <el-table-column prop="name" label="流向" width="220"></el-table-column>
        <el-table-column prop="createUser" label="创建人" width="120"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange1"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="title" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialogB"   :visible.sync="dialogVisible" width="1100px" center>
      <span>
        <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="100px" size="mini">
          <div class="inpBox">
            <el-form-item label="单位名称:" prop="company" class="inpBox1">
              <el-input  placeholder="" maxlength="20"  v-model="addFrom.company" ></el-input>
            </el-form-item>
            <el-form-item label="联系人:" prop="person" class="inpBox1">
              <el-input  placeholder="" maxlength="20"  v-model.trim="addFrom.person" ></el-input>
            </el-form-item>
              <el-form-item label="联系电话:" prop="phone" class="inpBox1">
              <el-input  placeholder="" maxlength="11"  type="tel" v-model="addFrom.phone" ></el-input>
            </el-form-item>
            <hr>
            <mapAddress :addFrom="addFrom"  v-if="flag"></mapAddress>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 简化地址新建修改 -->
    <el-dialog  :title="title" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialogB"   :visible.sync="JHmarker" width="500px" center>
      <span>
        <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="100px" size="mini">
          <div class="inpBox">
            <el-form-item label="单位名称:" prop="company" class="inpBox1">
              <el-input  placeholder="" maxlength="20"  v-model="addFrom.company" ></el-input>
            </el-form-item>
            <el-form-item label="联系人:" prop="person" class="inpBox1">
              <el-input  placeholder="" maxlength="20"  v-model.trim="addFrom.person" ></el-input>
            </el-form-item>
              <el-form-item label="联系电话:" prop="phone" class="inpBox1">
              <el-input  placeholder="" maxlength="11"  type="tel" v-model="addFrom.phone" ></el-input>
            </el-form-item>
             <el-form-item label="详细地址:" prop="address" class="inpBox1" :rules="{ required: true, message: '请输入详细地址', trigger: 'blur' }">
              <el-input  placeholder="" maxlength="20"  v-model.trim="addFrom.address" ></el-input>
            </el-form-item>
            <el-form-item label="备注:" class="inpBox1" prop="remark">
              <el-input v-model="addFrom.remark" ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="JHmarker = false">取 消</el-button>
        <el-button type="primary" @click="JHsaveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sAddressList, sAddressUpdate, sAddressAdd, sAddressDelete, addSimplification, updateSimplification } from '@/api/newTMS'
import shengShiXian from '@/components/common/shengShiXian.vue'
import { formatterRowEmpty } from '@/utils/util'
import mapAddress from '@/views/newTMS/publicFiles/addressMapTMS.vue'
export default {
  name: 'selectAddress',
  props: ['type', 'tenantId', 'iszujian', 'searchStr'],
  components: {
    shengShiXian,
    mapAddress
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      h: 500,
      dialogXzdz: false,
      currentRow: null,
      xzdz: [],
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      isShowAddressInfo: true,
      addFrom: {},
      title: '新建',
      dialogVisible: false,
      rules: {
        // company: [
        //   { required: true, message: '请输入单位名称', trigger: 'blur' }
        // ],
        person: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { pattern: this.rule.xingming, message: '联系人必须2-20 个汉字' }

        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        type: [
          { required: true, message: '请选择地址类型', trigger: 'blur' }
        ],
        mapShengShiQu: [
          { required: true, message: '请在地图上选择地址', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请在地图上选择地址', trigger: 'blur' }
        ]
      },
      flag: true,
      ids: [],
      JHmarker: false,
      btnFlg: [],
      btnIdArr: ['01N00A0100', '01N00A0200', '01N00A0300', '01N00A0400']
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 166) + 'px'
    this.dialogXzdz = true
    // console.log(this.dialogXzdz, 'this.dialogXzdz子组件')
    this.btnFlg = getBtn(this.btnIdArr, '/addressTMS')
    if (this.tenantId) {
      this.searchFrom.tenantId = this.tenantId
    }
    if (this.searchStr) {
      this.$set(this.searchFrom, 'address', this.searchStr)
    }
    // this.searchFrom.type = this.type
    this.getAddress()
  },
  methods: {
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 地区选中
    handleChange (value) {
      if (value) {
        this.searchFrom.provinceCode = value[0].areaCode
        this.searchFrom.cityCode = value[1].areaCode
        this.searchFrom.areaCode = value[2].areaCode
      }
    },
    // 双击行
    dbSelected (row) {
      if (this.iszujian == 1) {
        this.xzdzFn()
      }
    },
    handleCurrentChange (val) {
      this.currentRow = val
    },
    xzdzFn () {
      if (this.currentRow == null) {
        this.$alert('请选择一条地址', '系统提示')
      } else {
        this.$emit('handleCurrentChange', this.currentRow)
      }
    },
    // 获取地址
    getAddress () {
      sAddressList(this.searchFrom).then(res => {
        this.xzdz = res.list
        this.total = res.total
      })
    },
    // 查选
    searchFn () {
      this.getAddress(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getAddress(this.searchFrom)
    },
    // 当前页
    handleCurrentChange1 (val) {
      this.searchFrom.pageNo = val
      this.getAddress(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
        // type: this.type
      }
      this.isShowAddressInfo = false
      // 这里搞个定时器重新载入一下组件就可以触发组件拉取数据
      setTimeout(() => {
        this.isShowAddressInfo = true
      }, 0)
    },
    closeDialog () {
      // this.$emit('destroy')
      this.$emit('dialogXzdz', false)
      this.derverFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    handleClose () {
      this.$emit('closeAddGroupBuying', false)
    },
    closeDialogB () {
      this.addFrom = {}
      // this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
      this.dialogVisible = false
      this.JHmarker = false
    },
    addressAddJH () {
      this.title = '新建'
      this.JHmarker = true
      this.isAdd = true
      this.addFrom = {}
    },
    JHsaveFn (formName) {
      this.addFrom.isDefault = 1
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.addFrom.remark) {
            this.$set(this.addFrom, 'remark', '')
          }
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            addSimplification(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.JHmarker = false
              this.getAddress(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            updateSimplification(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.JHmarker = false
              this.getAddress(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    addressAdd () {
      this.title = '新建'
      this.dialogVisible = true
      this.isAdd = true
      this.flag = true
      this.addFrom = {}
    },
    // 修改
    modifyRegion (row) {
      console.log(row, '当前行')
      if (row.provinceCode) {
        this.addFrom = JSON.parse(JSON.stringify(row))
        this.title = '修改'
        this.dialogVisible = true
        this.isAdd = false
        this.flag = true
      } else {
        this.addFrom = JSON.parse(JSON.stringify(row))
        this.title = '修改'
        this.JHmarker = true
        this.isAdd = false
      }
    },
    saveFn (formName) {
      this.addFrom.isDefault = 1
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.addFrom.remark) {
            this.$set(this.addFrom, 'remark', '')
          }
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sAddressAdd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getAddress(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sAddressUpdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getAddress(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delDeiver (row) {
      this.ids = []
      this.ids.push(row.id)
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sAddressDelete({ ids: this.ids }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getAddress(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    }
  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-table .warning-row {
    background: #c4fbd2!important;
  }
 /deep/.el-form {
  width: 100%;
 }
.inpBox1 /deep/.el-input__inner{
  width: 220px;
}
</style>
